module.exports = __webpack_public_path__ + "static/img/CBF.efa9fd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CBF.jpg
// module id = emI0
// module chunks = 1